// Importing the LabelDescription component
import { Description } from "components/description"; // Importing the Description component

import "./verifying-screen.scss"; // Importing the SCSS file for styling
import { ProgressBar } from "@storybook";

interface IVerifyingScreen {
  footer?: string | JSX.Element; // Optional footer text or element
  description?: string | JSX.Element; // Optional description text or element
}

/**
 * VerifyingScreen component displays a verification screen with an optional description, and footer.
 *
 * @param {IVerifyingScreen} props - The properties object for the VerifyScreen component.
 * @param {string | JSX.Element} [props.description] - The description text or element to display.
 * @param {string | JSX.Element} [props.footer] - The footer text or element to display.
 * @returns {JSX.Element} The rendered VerifyingScreen component.
 */
export const VerifyingScreen = ({
  description = "",
  footer = "",
}: IVerifyingScreen) => {
  return (
    <div className="verifying-screen-wrapper">
      {/* Centering the content */}
      <div className="content-center">
        <div className="w-100">
          {/* Container for the image and text elements */}
          <div className="flex-column-center gap-16">
            <Description
              content={description}
              className="text-center verifying-screen-wrapper__label"
            />
            <ProgressBar max={100} delay={500} />
          </div>
          {/* Conditionally render the footer if provided */}
          {footer && (
            <div className="sublabel verify-screen-wrapper__footer">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
